import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-2 bg-transparent opacity-60" data-id="element-148">
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} viewport={{
      once: true
    }} className="w-24 md:w-48 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent origin-right" data-id="element-149" />
      <motion.div initial={{
      scale: 0,
      opacity: 0,
      rotate: -45
    }} whileInView={{
      scale: 1,
      opacity: 1,
      rotate: 45
    }} transition={{
      duration: 0.8,
      delay: 0.3,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="mx-4 w-2 h-2 border border-gold transform rotate-45" data-id="element-150" />
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} viewport={{
      once: true
    }} className="w-24 md:w-48 h-[1px] bg-gradient-to-r from-gold via-gold to-transparent origin-left" data-id="element-151" />
    </div>;
}